import { render, staticRenderFns } from "./MonitoringDashboardIndex.vue?vue&type=template&id=4235f115&scoped=true&"
import script from "./MonitoringDashboardIndex.vue?vue&type=script&lang=js&"
export * from "./MonitoringDashboardIndex.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringDashboardIndex.vue?vue&type=style&index=0&id=4235f115&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235f115",
  null
  
)

export default component.exports